import {
    Component,
    OnInit,
    PLATFORM_ID,
    ViewChild,
    ChangeDetectorRef,
    HostListener,
    Inject,
} from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

// ** rxjs
import { finalize, switchMap, tap } from 'rxjs/operators';
import { of, Observable, forkJoin } from 'rxjs';

// ** service
import { LayoutService } from '@app/core/services/layout.service';
import { NewsService } from '@app/core/services/news.service';
import { SuccessService } from '@app/core/services/success.service';

// ** translate
import { TranslateService } from '@ngx-translate/core';

//  ** env
import { environment } from '@env/environment';

import { SwiperComponent } from 'swiper/angular';

@Component({
    selector: 'app-success',
    templateUrl: './success.component.html',
    styleUrls: ['./success.component.scss'],
})
export class SuccessComponent implements OnInit {
    @ViewChild(SwiperComponent, { static: false }) swiper: SwiperComponent;
    isBrowser: boolean;

    // ** swiper 顯示與否，等資料叫好再 render
    showSwiper = false;
    // ** swiper current 頁數 reference
    swiperPageRef = 1;
    // ** swiper 顯示的數量
    perPage = 3;

    // ** 全文章資料
    fullPiece;
    // ** 相關 topics arr
    relatedPieces = [];
    // ** 全部成功案例清單
    successSheet;
    // ** 目前閱讀的文章 tags arr
    relation = [];

    // ** 全新聞清單
    allNewsSheet;
    // ** 相關新聞清單
    relatedNews = [];

    solutionMap = {
        教育: 'edu',
        政府機構: 'gov',
        運輸物流: 'transport',
        能源醫療: 'medical',
        工業商業: 'business',
        資安: 'info-security',
        國安: 'national-security',
        治安: 'public-security',
    };

    @HostListener('window:resize', ['$event'])
    onResize(event: Event): void {
        if (this.isBrowser) this.onWindowResize();
    }

    // - 依據 window size 調整 swiper 顯示 slide 數量
    onWindowResize() {
        const lg = window.innerWidth > 1024;
        const md = window.innerWidth > 440 && window.innerWidth <= 1024;
        const sm = window.innerWidth <= 440;
        this.perPage = lg ? 3 : md ? 2 : sm ? 1 : 0;
        this.updateScroll();
    }

    constructor(
        @Inject(DOCUMENT) private document: Document,
        @Inject(PLATFORM_ID) private platformId,
        private route: ActivatedRoute,
        private router: Router,
        private title: Title,
        private successService: SuccessService,
        private layoutService: LayoutService,
        private cdr: ChangeDetectorRef,
        private newsService: NewsService,
        private translateService: TranslateService,
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        if (this.isBrowser) this.onWindowResize();
    }

    ngOnInit(): void {
        this.initPage();
    }

    initPage() {
        this.route.params
            .pipe(
                tap(() => this.layoutService.setPageLoading(true)),
                tap(params => {
                    const canonical = this.document.querySelector(
                        'link[rel="canonical"]',
                    ) as HTMLAnchorElement | null;
                    if (canonical)
                        canonical.href = `https://www.kunyoutech.com.tw/success/${params['title']}`;
                }),
                switchMap(params =>
                    this.getFullPiece$(`${params['title']}.json`),
                ),
                tap(res => (this.fullPiece = res)),
                tap(res => this.setTitle(res?.Name)),
                tap(() => (this.relation = [...this.fullPiece.MetaTags])),
                tap(() => this.getSuccessSheet()),
                tap(() => this.getAllNews()),
                finalize(() => this.layoutService.setPageLoading(false)),
            )
            .subscribe();
    }

    // - 設定 title for seo
    setTitle(title) {
        if (title)
            this.title.setTitle(`${environment.projectTitleCH} - ${title}`);
    }

    goExploreMoreSolutions(postfix) {
        return `/solutions/explore/${this.solutionMap[postfix]}`;
    }

    // - 取得成功案例清單
    getSuccessSheet() {
        of(this.layoutService.setPageLoading(true))
            .pipe(
                switchMap(() => this.getSuccessSheet$()),
                tap(res => (this.successSheet = [...res])),
                tap(() => this.findRelated()),
                finalize(() => this.layoutService.setPageLoading(false)),
            )
            .subscribe();
    }

    // - 找到成功案列相關主題（tag 大對比）
    // findRelated() {
    // 	if (!this.relation.length) this.relatedPieces = [...this.successSheet.slice(0, 9)];
    // 	this.successSheet.some((piece, idx) => {
    // 		if (this.relatedPieces.length === 9) return true;
    // 		// ** 找相關 tag
    // 		const isRelated = piece.MetaTags.some((x) =>
    // 			this.relation.some((y) => new RegExp(y).test(x) || new RegExp(x).test(y))
    // 		);
    // 		// ** filter 自己
    // 		const isSelf = piece.NameEN === this.fullPiece.NameEN;
    // 		if (isRelated && !isSelf) this.relatedPieces = [...this.relatedPieces, piece];
    // 	});

    // 	this.initSwiper();
    // }

    // - 找到成功案列相關主題
    findRelated() {
        const mainType = this.fullPiece?.Type?.split(' ｜ ')[0];
        if (!mainType) return this.preventShowSuccessNone();
        this.successSheet.some((piece, idx) => {
            if (this.relatedPieces.length === 9) return true;
            // const isRelated = piece.MetaTags.some(
            // 	(x) => new RegExp(mainType, 'i').test(x) || new RegExp(x, 'i').test(mainType)
            // );
            // const isRelated = piece?.Type?.split(' ｜ ')[0];

            // ** 找相關 tag，mainType against mainType
            const isRelated =
                new RegExp(piece?.Type?.split(' ｜ ')[0], 'i').test(mainType) ||
                new RegExp(mainType, 'i').test(piece?.Type?.split(' ｜ ')[0]);

            // ** filter 自己
            const isSelf = piece.NameEN === this.fullPiece.NameEN;
            if (isRelated && !isSelf)
                this.relatedPieces = [...this.relatedPieces, piece];
        });
        if (!this.relatedPieces.length) this.preventShowSuccessNone();

        this.initSwiper();
    }

    // - 避免成功案列相關主題全部都沒有
    preventShowSuccessNone() {
        this.relatedPieces = [...this.successSheet.slice(0, 9)].filter(
            x => x.NameEN !== this.fullPiece.NameEN,
        );
    }

    // - 初始化 swiper
    initSwiper() {
        setTimeout(() => (this.showSwiper = true));
        setTimeout(() =>
            this.swiper?.swiperRef?.on('slideChange', e =>
                this.updatePageIdx(),
            ),
        );
    }

    // - 更新頁數
    updatePageIdx() {
        setTimeout(() => {
            this.swiperPageRef = this.swiper?.swiperRef
                ? this.swiper?.swiperRef.activeIndex + 1
                : 1;
            this.cdr.detectChanges();
        });
    }

    // - manual update swiper scroll for ng lifecycle hotfix
    updateScroll() {
        setTimeout(() => {
            this.swiper?.swiperRef?.scrollbar.updateSize();
            this.swiper?.swiperRef?.scrollbar.setTranslate();
        });
    }

    // - 前往成功案例內頁
    goToSuccess(NameEN) {
        of(this.layoutService.setPageLoading(true))
            .pipe(
                tap(() => this.resetData()),
                tap(() =>
                    setTimeout(() =>
                        this.router.navigateByUrl(`success/${NameEN}`),
                    ),
                ),
                finalize(() => this.layoutService.setPageLoading(false)),
            )
            .subscribe();
    }

    // - 取得所有文章的 sheet，排序時間
    getAllNews() {
        of(this.layoutService.setPageLoading(true))
            .pipe(
                switchMap(() =>
                    forkJoin([this.getNews$(), this.getElectronicNews$()]),
                ),
                tap(([news, eNews]) => {
                    this.allNewsSheet = [...news, ...eNews];
                    this.allNewsSheet.sort((a, b) => {
                        const dateA = new Date(a.Date);
                        const dateB = new Date(b.Date);
                        return dateB.getTime() - dateA.getTime();
                    });
                }),
                tap(() => this.findRelatedNews()),
                finalize(() => this.layoutService.setPageLoading(false)),
            )
            .subscribe();
    }

    // - 找到相關新聞主題
    findRelatedNews() {
        this.allNewsSheet.some((piece, idx) => {
            if (this.relatedNews.length === 9) return true;
            // ** 找相關 tag
            const isRelated = piece.Tags.some(x =>
                this.relation.some(
                    y =>
                        new RegExp(y, 'i').test(x) ||
                        new RegExp(x, 'i').test(y),
                ),
            );
            if (isRelated) this.relatedNews = [...this.relatedNews, piece];
        });
        console.log(this.relatedNews);
        console.log(this.relation);
    }

    // - 檢視文章
    goViewNews(prefix, fileTitle) {
        of(this.layoutService.setPageLoading(true))
            .pipe(
                tap(() =>
                    setTimeout(() =>
                        this.router.navigateByUrl(
                            `newsCenter/${prefix}/${fileTitle}`,
                        ),
                    ),
                ),
                finalize(() => this.layoutService.setPageLoading(false)),
            )
            .subscribe();
    }

    resetData() {
        this.relation = [];
        this.relatedPieces = [];
        this.relatedNews = [];
        this.showSwiper = false;
    }

	/**
	 * 英文名稱轉換為對應的 key
	 * ex：'mobile-public-service-duty-app' -> 'mobilePublicServiceDutyApp'
	 */
    getSuccessKeyFromNameEN(nameEN: string): string {
        if (!nameEN) return '';

        return nameEN
            .replace(/-([a-z])/g, (match, letter) => letter.toUpperCase())
            .replace(/^[a-z]/, letter => letter.toLowerCase());
    }

    /**
     * 翻譯後的類型部分（可指定取｜之前或之後的部分）
     * @param nameEN 名稱的英文版本
     * @param part 'before' | 'after' | 'all' - 指定要取得的部分
     * @returns 根據part參數返回對應的部分
     */
    getTranslatedTypeParts(
        nameEN: string,
        part: 'before' | 'after' | 'all' = 'all',
    ): string | string[] {
        const typeKey = `solutions.explore.successCases.${this.getSuccessKeyFromNameEN(
            nameEN,
        )}.type`;
        const translatedType = this.translateService.instant(typeKey);
        const parts = translatedType.split(' ｜ ');

        switch (part) {
            case 'before':
                return parts[0] || '';
            case 'after':
                return parts.slice(1);
            case 'all':
            default:
                return parts;
        }
    }

    /**
     * 翻譯後的 pain descList 陣列
     * @param type 'problem' | 'challenge' - 要取的類型
     * @returns 翻譯後的文字
     */
    getPainDescList(type: 'problem' | 'challenge'): string[] {
        if (!this.fullPiece?.NameEN) return [];

        const key = `solutions.explore.successCases.${this.getSuccessKeyFromNameEN(
            this.fullPiece.NameEN,
        )}.pain.${type}.descList`;
        const translated = this.translateService.instant(key);

        return Array.isArray(translated) ? translated : [];
    }

    // ? API
    getFullPiece$(file: string): Observable<any> {
        return this.successService.getFullPiece(file).pipe();
    }

    getSuccessSheet$(): Observable<any> {
        return this.successService.getSuccessSheet().pipe();
    }

    getNews$(): Observable<any> {
        return this.newsService.getNews().pipe();
    }

    getElectronicNews$(): Observable<any> {
        return this.newsService.getElectronicNews().pipe();
    }
}
